import axios from 'axios';

const blinkscribeapi = axios.create({
  baseURL: process.env.REACT_APP_API_BS_BASE || "https://api.prd.brainymed.com/bs",
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});


blinkscribeapi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      localStorage.removeItem('auth');
    //  window.location.replace('/auth');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
let isRefreshing = false;

const refreshAuthToken = async () => {
  try {
    const accessToken = localStorage.getItem('auth');
    const response = await blinkscribeapi.post(
      '/v1/auth/refresh-token',
      { "access_token": accessToken },
      { headers: { 'Content-Type': 'application/json' } }
    );

    if (response && response.status === 200) {
      localStorage.setItem('auth', response.refresh_token);
      return response.refresh_token;
    } else {
     //localStorage.removeItem('auth');
      // window.location.replace('/login');-------
      throw new Error('Failed to refresh token');
    }
  } catch (error) {
    //localStorage.removeItem('auth');
    // window.location.replace('/login');-------------
    console.error("Failed to refresh token:", error);
    throw error;
  }
};

blinkscribeapi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const newToken = await refreshAuthToken();
          if (newToken) {
            
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            isRefreshing = false;

            return blinkscribeapi(originalRequest);
          }
        } catch (refreshError) {
          isRefreshing = false;
          return Promise.reject(refreshError);
        }
      } else {
    
       // localStorage.removeItem('auth');
     
        return Promise.reject(error);
      }
    }

    if (!originalRequest._retry) {
      //localStorage.removeItem('auth');
    }

    return Promise.reject(error);
  }
);

export default blinkscribeapi;
